<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for="projectinput2">{{ $t("labels.heightCm") }}</label>
          <div class="input-group">
            <input class="form-control" type="number" v-model.number="patient.height">
            <div class="input-group-append">
              <span class="input-group-text" id="basic-addon2">cm</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="projectinput2">{{ $t("labels.weightKg") }}</label>
          <div class="input-group">
            <input class="form-control" type="number" v-model.number="patient.weight">
            <div class="input-group-append">
              <span class="input-group-text" id="basic-addon2">kg</span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="projectinput2">{{ $t("labels.dateOfChange") }}</label>
          <date-picker :lang="$i18n.locale" appendtobody format="DD/MM/YYYY" type="date" v-model="patient.dateOfChangeForNew" width="100%" v-if="sizeIntent == 'new'"></date-picker>
          <date-picker :lang="$i18n.locale" appendtobody format="DD/MM/YYYY" type="date" v-model="patient.dateOfChangeForEdit" width="100%" v-else-if="sizeIntent == 'edit'"></date-picker>
        </div>
      </div>
    </div>
    <div class="row" v-if="$route.name != 'newPatient'">
      <div class="col-md-1">
        <button @click.prevent="$emit('savesizechange')" class="btn btn-success" type="button">
          <i class="icon-note"></i>
          {{ this.$t("labels.save") }}
        </button>
      </div>
      <div class="col-md-1">
        <button @click.prevent="$emit('cancelsizechange')" class="btn btn-warning" type="button">
          <i class="icon-note"></i>
          {{ this.$t("labels.cancel") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        props: {
          patient: Object,
          sizeIntent: String
        }
    }
</script>

<style></style>